"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var device_detection_1 = require("../utils/device-detection");
var convertUIConfigForIOS = function (params) { return ((0, tslib_1.__assign)((0, tslib_1.__assign)({}, params), { disableControlWithClickOnPlayer: true, disableControlWithKeyboard: true, hideMainUI: true, nativeBrowserControls: true })); };
var convertUIConfigForAndroid = function (params) { return ((0, tslib_1.__assign)((0, tslib_1.__assign)({}, params), { disableControlWithClickOnPlayer: true, disableControlWithKeyboard: true })); };
var convertToDeviceRelatedConfig = function (params) {
    if ((0, device_detection_1.isIOS)()) {
        return convertUIConfigForIOS(params);
    }
    if ((0, device_detection_1.isAndroid)()) {
        return convertUIConfigForAndroid(params);
    }
    return params;
};
exports.default = convertToDeviceRelatedConfig;
//# sourceMappingURL=config.js.map